import React from 'react';
import {
  FieldValues, useController, Path, PathValue,
} from 'react-hook-form';
import EmailsChips, { EmailsChipsProps } from '.';
import { CommonReactHookFormProps } from '../types';

interface RHFEmailsChipsProps<
  Value, FormFields extends FieldValues,
> extends EmailsChipsProps, CommonReactHookFormProps<FormFields> {
  onSelectChange?: (data: Value) => void;
}

function RHFEmailsChips<Value, FormFields extends FieldValues>(
  props: RHFEmailsChipsProps<Value, FormFields>,
) {
  const {
    name,
    control,
    value,
    label,
    onSelectChange,
    ...rest
  } = props;

  const {
    field,
    fieldState: { error },
  } = useController<FormFields>({
    name,
    control,
    rules: { required: true },
    defaultValue: value as PathValue<FormFields, Path<FormFields>>,
  });

  const { onChange } = field;

  const handleChange = (event: any) => {
    onChange(event);
    if (onSelectChange) {
      onSelectChange(event);
    }
  };

  return (
    <EmailsChips
      label={label}
      error={error}
      value={field.value}
      onChange={handleChange}
      {...rest}
    />
  );
}

RHFEmailsChips.defaultProps = {
  onSelectChange: () => { },
};

export default RHFEmailsChips;
